<div class="flex justify-center align-center box gaps-3">
  <span [class]="item?.iconClass || ''">
    <app-icon [name]="item.icon" [size]="item.iconSize"></app-icon>
  </span>
  <div class="flex column">
    <div class="flex box gaps-1 align-center">
      <span *ngIf="item.title.prefixIcon" [class]="item.title?.prefixIconClass || ''">
        <app-icon [name]="item.title.prefixIcon" [size]="item.title.prefixIconSize"></app-icon>
      </span>
      <span *ngIf="item.title.prefix" [class]="'small text-400 ' + item.title.prefixClass || ''">
        {{item.title.prefix}}
      </span>
      <span *ngIf="item.title.text" [class]="'h5 weight-semibold m-0 ' + item.title.class || ''">{{item.title.text}}</span>
      <span *ngIf="item.title.number" [class]="'h5 weight-semibold m-0 ' + item.title.class || ''">{{item.title.number | number:'1.0-0'}}</span>
      <span *ngIf="item.title.suffix" [class]="'small text-400 weight-medium ' + item.title.suffixClass || ''">{{item.title.suffix}}</span>
      <span *ngIf="item.title.suffixIcon" [class]="item.title.suffixClass || ''">
        <app-icon [name]="item.title.suffixIcon" [size]="item.title.suffixIconSize"></app-icon>
      </span>
    </div>

    <div class="flex box gaps-1 align-center text-400 small" *ngIf="item?.subtitle">
      <span *ngIf="item.subtitle.prefixIcon" [class]="item.subtitle.prefixIconClass || ''">
        <app-icon [name]="item.subtitle.prefixIcon" [size]="item.subtitle.prefixIconSize"></app-icon>
      </span>
      <span *ngIf="item.subtitle.prefix" [class]="'weight-medium ' + item.subtitle.prefixClass || ''">{{item.subtitle.prefix}}</span>
      <span *ngIf="item.subtitle.text" [class]="item.subtitle.class || ''">{{item.subtitle.text }}</span>
      <span *ngIf="item.subtitle.number" [class]="item.subtitle.class || ''">{{item.subtitle.number | number:'1.0-0' }}</span>
      <span *ngIf="item.subtitle.suffix" [class]="'weight-medium ' + item.subtitle.suffixClass || ''">{{item.subtitle.suffix}}</span>
      <span *ngIf="item.subtitle.suffixIcon" [class]="item.subtitle?.suffixIconClass || ''">
        <app-icon [name]="item.subtitle.suffixIcon" [size]="item.subtitle.suffixIconSize"></app-icon>
      </span>
    </div>
  </div>
</div>
